// Queries
import preOrders from "./PreOrdersQuery.gql";

// Mutations
import addPreOrder from "./AddPreOrderMutation.gql";

export const Query = {
    preOrders,
};
export const Mutation = {
    addPreOrder,
};
